import {
  CATEGORY_ATHLETES_REQUEST,
  CATEGORY_ATHLETES_SUCCESS,
  CATEGORY_ATHLETES_FAILURE,
} from 'actions';

/**
 * Stores per-category athlete lists, keyed by slot key.
 * Used for lazy loading on hover; prevents redundant fetches.
 *
 * State shape:
 *   isFetching: string[]  — slotKeys currently loading
 *   isFetched:  string[]  — slotKeys that have loaded (don't re-fetch)
 *   data: { [slotKey]: Athlete[] }
 *
 * Athlete shape: { id, firstName, lastName, rank }
 */
const initialState = {
  isFetching: [],
  isFetched: [],
  data: {},
};

export const categoryAthletesReducer = (state = initialState, action) => {
  switch (action.type) {
    case CATEGORY_ATHLETES_REQUEST:
      return {
        ...state,
        isFetching: [...state.isFetching, action.slotKey],
      };

    case CATEGORY_ATHLETES_SUCCESS:
      return {
        isFetching: state.isFetching.filter(k => k !== action.slotKey),
        isFetched: [...state.isFetched.filter(k => k !== action.slotKey), action.slotKey],
        data: { ...state.data, [action.slotKey]: action.athletes },
      };

    case CATEGORY_ATHLETES_FAILURE:
      return {
        ...state,
        isFetching: state.isFetching.filter(k => k !== action.slotKey),
      };

    default:
      return state;
  }
};
